import http from './http';
import { OK, CREATED } from '../utils/constant';

const InternalTaskService = {
  // Create a new internal task
  createTask: async (payload) => {
    try {
      const response = await http.POST('internal-tasks', payload);
      if (response && (response.code === OK || response.code === CREATED)) {
        return response.data || response;
      }
      return response;
    } catch (error) {
      console.error('Error creating internal task:', error);
      throw error;
    }
  },

  // Get tasks received by the current user
  getReceivedTasks: async (query = {}) => {
    try {
      const queryString = new URLSearchParams(query).toString();
      const response = await http.GET(`internal-tasks/received?${queryString}`);
      if (response.code === OK && response.data) {
        return response.data;
      }
      return [];
    } catch (error) {
      console.error('Error fetching received tasks:', error);
      throw error;
    }
  },

  // Get tasks sent by the current user
  getSentTasks: async (query = {}) => {
    try {
      const queryString = new URLSearchParams(query).toString();
      const response = await http.GET(`internal-tasks/sent?${queryString}`);
      if (response.code === OK && response.data) {
        return response.data;
      }
      return [];
    } catch (error) {
      console.error('Error fetching sent tasks:', error);
      throw error;
    }
  },

  // Update task status
  updateTaskStatus: async (taskId, status) => {
    try {
      const response = await http.PUT(`internal-tasks/${taskId}/status`, { status });
      if (response.code === OK && response.data) {
        return response.data;
      }
      return null;
    } catch (error) {
      console.error('Error updating task status:', error);
      throw error;
    }
  },

  // Get unread tasks count
  getUnreadCount: async () => {
    try {
      const response = await http.GET('internal-tasks/unread-count');
      if (response.code === OK && response.data) {
        return response.data.count || 0;
      }
      return 0;
    } catch (error) {
      console.error('Error fetching unread count:', error);
      return 0;
    }
  },
};

export default InternalTaskService;
